export const COUPON_TYPES = [
  {value: 'promotion', text:'Promotion'},
  {value: 'credits', text:'Credits'},
  {value: 'ZONE-UNLOCK', text: 'Zone unlock'},
  {value: 'FIRST-USE', text: 'First use'}
];
export const COUPON_DISCOUNT_TYPES = [
  {value: 'percentage', text:'Percentage'},
  {value: 'price', text:'Price'},
  {value: 'trip', text:'Trip'}
];

export const COUPON_USE_TYPES = [
  {value: 'dates', text:'Dates'},
  {value: 'counter', text:'Counter'}
];
